import { Component, OnInit, Input } from '@angular/core';
import { Product } from '@models/product';
import { environment } from '@environments/environment';

@Component({
  selector: 'gob-diapo',
  templateUrl: './diapo.component.html',
  styleUrls: ['./diapo.component.css']
})
export class DiapoComponent implements OnInit {
  @Input() product: Product;
  indImg: number=0;

  constructor() { }

  ngOnInit(): void {
  }

  /* getImage(ind: number){
    return `${environment.imgUrl}/product/${this.product.images[ind].name}`;
  } */

  getImage(image : any){
    return `${environment.imgUrl}/product/${image.name}`;
  }

  /**
   * The main image of the product, or the first one if no main image is set, or null if no image is set.
   */
  get mainImage() {
    return this.product.images?.find((img: { isMain: any; }) => img.isMain === 'true') || null;
  }

  /**
   * Retrieves all images of the product that are not set as the main image.
   * @returns An array of images that are not marked as the main image.
   */
  get otherImages() {
    return this.product.images?.filter((img: { isMain: any; }) => img.isMain === 'false') || [];
  }

  /**
   * Returns the background color based on the given tab.
   * @param tab Tab to return the background color for.
   * @returns The background color as a string.
   */
  getColor(tab: string): string {
    switch (tab) {
      case 'news':
        return 'var(--color-green-light)';
      case 'promos':
        return 'var(--color-orange)';
      case 'coeur':
        return 'var(--color-red)';
      case 'goldngob':
        return 'var(--color-golden)';
      default:
        return 'var(--color-green)';
    }
  }

  /**
   * Returns the style for a given tab based on the window width.
   * If the window width is greater than 667, the style for the desktop is returned.
   * Otherwise, the style for mobile is returned.
   * @param tab Tab to return the style for.
   * @returns The style for the given tab as an object.
   */
  getStyle(tab: string){
    let style: any={
      backgroundColor: this.getColor(tab),
    }

    let styleMobile: any={
      backgroundColor: this.getColor(tab),
    }

    if(window.innerWidth>667)
      return style;
    else
      return styleMobile
  }

}
